module.exports = __webpack_public_path__ + "img/logo-mini.6990d2c8.png";